import { useEffect } from 'react';

export const Schedule = () => {
  useEffect(() => {
    // Redirect to Google Calendar booking page
    window.location.href = 'https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ3-Q5PB32iYcYOFy0AfHcJQEewh-0EC12gx8qLVXkzCXMl3Ok1RTHDMZLWUv-lyg1PdwLj-W9SR';
  }, []);

  return (
    <div style={{ 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center', 
      height: '100vh',
      fontSize: '18px',
      color: '#4a5568'
    }}>
      Redirecting to scheduling page...
    </div>
  );
};
